import React from 'react';
import PropTypes from 'prop-types';
import { fieldInputPropTypes, fieldMetaPropTypes } from 'redux-form/immutable';

import formControl from './formControl';
import { moneyToString, stringToMoney, stringToMoneyNegative } from '../../lib/common';

// Takes currency in cents but displays in floats.
function PriceInput({
  input: { value, onChange, onBlur, ...otherInputProps },
  disabled,
  testID,
  placeholder,
}) {
  return (
    <input
      {...otherInputProps}
      className="form-control"
      value={value}
      type="text"
      placeholder={placeholder}
      onChange={event => onChange(event.target.value)}
      onBlur={event => onBlur(event.target.value)}
      disabled={disabled}
      data-testid={testID}
    />
  );
}

PriceInput.defaultProps = {
  testID: undefined,
  placeholder: 'Pris',
  disabled: false,
};

PriceInput.propTypes = {
  input: PropTypes.shape(fieldInputPropTypes).isRequired,
  meta: PropTypes.shape(fieldMetaPropTypes).isRequired,
  testID: PropTypes.string,
  disabled: PropTypes.bool,
  placeholder: PropTypes.string,
};

const extendedPriceInput = formControl(PriceInput);
extendedPriceInput.normalize = value => stringToMoney(value);
extendedPriceInput.normalizeNegative = value => stringToMoneyNegative(value);
extendedPriceInput.format = value => moneyToString(value);

export default extendedPriceInput;
